import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-cost-hour-tag-definitions',
  templateUrl: './cost-hour-tag-definitions.component.html',
  styleUrls: ['./cost-hour-tag-definitions.component.css']
})
export class CostHourTagDefinitionsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.CostHourTagDefinitions.columns;
    this.data = this.report.CostHourTagDefinitions.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.CostHourTagDefinitions.data;
    const gridInstance = this.gridContext.getInstance('CostHourTagDefinitions');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/cost-hour-tag-definitions/cost-hour-tag-definitions.component.ts